import React, { useMemo } from 'react';
import {
  IWidgetDataContextInput,
  WidgetDataProvider,
} from './widgetDataContext';
import { PluginsMarket } from './components/pluginsMarket';
import { PluginsProvider } from './pluginsContext';
import { PluginsUpdateModeProvider } from './pluginsUpdateModeContext';
import { EditorPlatformBIProvider } from '../providers/EditorPlatformBIProvider';
import { ExperimentsProvider } from '../providers/ExperimentsProvider';

const WIDGET_PLUGINS_SCOPE = 'widget-plugins';

export const WidgetPluginsManager: React.FC<IWidgetDataContextInput> = ({
  editorIntegrationAPI,
  widgetRef,
  widgetName,
}) => {
  return useMemo(
    () => (
      <ExperimentsProvider scope={WIDGET_PLUGINS_SCOPE}>
        <EditorPlatformBIProvider>
          <WidgetDataProvider
            editorIntegrationAPI={editorIntegrationAPI}
            widgetRef={widgetRef}
            widgetName={widgetName}
          >
            <PluginsProvider>
              <PluginsUpdateModeProvider>
                <PluginsMarket />
              </PluginsUpdateModeProvider>
            </PluginsProvider>
          </WidgetDataProvider>
        </EditorPlatformBIProvider>
      </ExperimentsProvider>
    ),
    // editorIntegrationAPI should not be added to dependencies as it may come directly from non-cached mapStateToProps
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [widgetRef],
  );
};
